import styled from '@emotion/styled';
import React from 'react';
import { LG_SCREEN_MIN, MD_SCREEN_MIN } from '../../../../modules/Styleguide';
import { Section, SectionContent, ValuePropLabel } from '../styled';
import {
  EpisodeBuilderIcon,
  ImportAudioIcon,
  RecordingIcon,
  SoundEffectsIcon,
} from './CreatorToolsSvgs';

export function EasyToolsSection() {
  return (
    <StyledSection>
      <StyledSectionContent>
        <ValuePropLabel>Easy-to-use creation tools</ValuePropLabel>
        <div>
          <CreationTool>
            <RecordingIcon />
            <h3>Record from anywhere</h3>
            <p>
              Capture audio straight from your phone, iPad, or desktop computer
              using Anchor’s recording tools, compatible with most external
              microphones. Sync your recordings across all devices and access
              them anywhere.
            </p>
          </CreationTool>
          <CreationTool>
            <EpisodeBuilderIcon />
            <h3>Episode builder</h3>
            <p>
              Craft your episodes using building blocks of audio segments that
              are easy to visualize and don’t require any editing. Record your
              audio, arrange your segments, add transitions, and you’re set.
            </p>
          </CreationTool>
          <CreationTool>
            <ImportAudioIcon />
            <h3>Import existing audio or video</h3>
            <p>
              Create your episodes anywhere and drop the audio files into
              Anchor. Convert video files into audio, and mix-and-match existing
              segments with audio recorded in Anchor.
            </p>
          </CreationTool>
          <CreationTool>
            <SoundEffectsIcon />
            <h3>SFX &amp; background music</h3>
            <p>
              Add a background track behind any recording and break up longer
              segments using Anchor’s library of transitions and sound effects.
            </p>
          </CreationTool>
        </div>
      </StyledSectionContent>
    </StyledSection>
  );
}

const StyledSection = styled(Section)`
  background: #292f36;
`;

const StyledSectionContent = styled(SectionContent)`
  flex-direction: column;
  margin-top: 75px;
  margin-bottom: 75px;

  & > div {
    display: flex;
    flex-wrap: wrap;
  }
  h3,
  h4 {
    color: white;
  }
  h4 {
    text-align: center;
    margin-bottom: 12px;
  }

  @media (min-width: ${MD_SCREEN_MIN}px) {
    h4 {
      text-align: left;
      margin-bottom: 48px;
    }
  }
`;

const CreationTool = styled.div`
  padding: 24px;
  text-align: center;

  svg {
    width: 100%;
  }
  h3 {
    font-size: 1.6rem;
    margin-top: 0px;
    margin-bottom: 10px;
    padding: 0;
  }
  p {
    color: white;
  }
  @media (min-width: ${MD_SCREEN_MIN}px) {
    padding: 0 48px 0 0;
    text-align: left;
    width: 50%;
  }
  @media (min-width: ${LG_SCREEN_MIN}px) {
    width: 25%;
  }
`;
